import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";

import { AppRedirectComponent } from "./app-redirect.component";
import { reloadOnChunkLoadError } from "./shared/router/chunk-load-error.handler";
import { NotFoundComponent } from "./ui/not-found/not-found.component";

const routes: Routes = [
  {
    path: "",
    pathMatch: "full",
    component: AppRedirectComponent,
  },
  /* LAZY-LOADED MODULES */
  {
    path: "dashboard",
    loadChildren: () =>
      import("./dashboard/dashboard.module").then((mod) => mod.DashboardModule),
  },
  {
    path: "client",
    loadChildren: () =>
      import("./client/client.module").then((mod) => mod.ClientModule),
  },
  {
    path: "rate",
    loadChildren: () =>
      import("./rate/rate.module").then((mod) => mod.RateModule),
  },
  {
    path: "tier",
    loadChildren: () =>
      import("./tier/tier.module").then((mod) => mod.TierModule),
  },
  {
    path: "surcharge-type",
    loadChildren: () =>
      import("./surcharge-type/surcharge-type.module").then(
        (mod) => mod.SurchargeTypeModule,
      ),
  },
  {
    path: "team",
    loadChildren: () =>
      import("./team/team.module").then((mod) => mod.TeamModule),
  },
  {
    path: "location",
    loadChildren: () =>
      import("./location/location.module").then((mod) => mod.LocationModule),
  },
  {
    path: "margin-rule",
    loadChildren: () =>
      import("./margin-rule/margin-rule.module").then(
        (mod) => mod.MarginRuleModule,
      ),
  },
  {
    path: "location-group",
    loadChildren: () =>
      import("./location-group/location-group.module").then(
        (mod) => mod.LocationGroupModule,
      ),
  },
  {
    path: "country",
    loadChildren: () =>
      import("./country/country.module").then((mod) => mod.CountryModule),
  },
  {
    path: "carrier",
    loadChildren: () =>
      import("./carrier/carrier.module").then((mod) => mod.CarrierModule),
  },
  {
    path: "holiday",
    loadChildren: () =>
      import("./holiday/holiday.module").then((mod) => mod.HolidayModule),
  },
  {
    path: "activity",
    loadChildren: () =>
      import("./activity/activity.module").then((mod) => mod.ActivityModule),
  },
  {
    path: "potential",
    loadChildren: () =>
      import("./potential/potential.module").then((mod) => mod.PotentialModule),
  },
  {
    path: "notification",
    loadChildren: () =>
      import("./notification/notification.module").then(
        (mod) => mod.NotificationModule,
      ),
  },
  {
    path: "organization",
    loadChildren: () =>
      import("./organization/organization.module").then(
        (mod) => mod.OrganizationModule,
      ),
  },
  {
    path: "company",
    loadChildren: () =>
      import("./company/company.module").then((mod) => mod.CompanyModule),
  },
  {
    path: "not-found",
    component: NotFoundComponent,
  },
  {
    path: "**",
    component: NotFoundComponent,
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { errorHandler: reloadOnChunkLoadError }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
